export const isIntelbrasTenant = () => {
  const theme = localStorage.getItem('theme');

  return theme?.includes('intelbras') || theme?.includes('test-intelbras');
};
